import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, FileText } from "lucide-react";
import { LETTER_STATUS_LABEL, LETTER_STATUS_ORDER } from "@/lib/disputePlan";

function StatusGroup({ status, items }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4" data-testid={`letter-status-group-${status}`}>
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-slate-800">{LETTER_STATUS_LABEL[status]}</span>
        <span className="text-xs font-semibold text-slate-500" data-testid={`letter-status-count-${status}`}>{items.length}</span>
      </div>
      <ul className="mt-2 space-y-1.5">
        {items.map(({ doc, round }) => (
          <li key={doc.id}>
            <Link to="/app/documents" className="flex items-center gap-2 min-h-[44px] rounded-xl bg-slate-50 px-3 py-2 hover:bg-purple-50 transition-colors" data-testid={`letter-status-doc-${doc.id}`}>
              <FileText size={14} className="text-purple-600 shrink-0" />
              <span className="flex-1 min-w-0 truncate text-sm text-slate-800">{doc.title}</span>
              <span className="text-[11px] text-slate-500 shrink-0">Round {round}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function LetterStatusSection({ items }) {
  const [open, setOpen] = useState(true);
  const groups = LETTER_STATUS_ORDER.map((s) => ({ status: s, items: items.filter((i) => i.status === s) })).filter((g) => g.items.length > 0);
  return (
    <section id="letter-status" className="mt-10 scroll-mt-24" data-testid="dashboard-letter-status">
      <button type="button" onClick={() => setOpen((o) => !o)} className="flex w-full items-center justify-between min-h-[44px] text-left" data-testid="dashboard-letter-status-toggle" aria-expanded={open}>
        <h3 className="text-lg font-semibold text-slate-900">Your Letter Status</h3>
        <ChevronDown size={18} className={`text-slate-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (items.length === 0 ? (
        <p className="mt-2 text-sm text-slate-500" data-testid="dashboard-letter-status-empty">Your letters will appear here once you start Round 1.</p>
      ) : (
        <div className="mt-3 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
          {groups.map((g) => <StatusGroup key={g.status} status={g.status} items={g.items} />)}
        </div>
      ))}
    </section>
  );
}
